import axios from "axios";
import Constants from "../../../../../constants/Constants";
import {handleAuthenticationFailure, appendHttpUrlToApi} from "../../../../../utility/Utility";


export function xhrGetDbCompanyInfoList (jobId, onSuccess, onFailure) {
    if(Constants.DEV_MODE){
        requestDummyType1(jobId, onSuccess);
        return;
    }
    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'get',
        url: appendHttpUrlToApi(Constants.ROUTE.RECRUITER_DASHBOARD_COMMON_HANDLER),
        params: {
            job_id: jobId,
            action_type: Constants.REQUEST_ACTION_TYPE.RECRUITER_DASHBOARD_COMMON_HANDLER.GET_ACTION_GET_DB_ACCESS_DETAILS_FOR_JOB,
        }
    }).then( res =>{
        //Some initial processing like Valid User Check
        //finally call success as server call was success handle other cases in callback function
        let data = res.data.data ;

        //Some initial processing like Valid User Check
        //finally call success as server call was success handle other cases in callback function
        if(res.data && res.data.error === null) {
            let authVo = res.data.authentication_result;
            if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token) {
                onSuccess(data);
            }else{
                handleAuthenticationFailure()
            }
        }else{
            onFailure();
        }
    }).catch((error)=>{
        onFailure();
    });
}

export function xhrGetProfileViewNumber(parms, onSuccess, onFailure) {
    if(Constants.DEV_MODE){
        requestDummyType2(parms, onSuccess);
        return;
    }
    // Write Save Service Call
}

export function xhrSaveUpgradeInfo(data, onSuccess, onFailure) {
    if(Constants.DEV_MODE){
        responseDummyType2(data, onSuccess);
        return;
    }

    data.append("action_type",Constants.REQUEST_ACTION_TYPE.RECRUITER_DASHBOARD_COMMON_HANDLER.GET_ACTION_DATABASE_ACCESS_UPGRADE);
    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'post',
        url: appendHttpUrlToApi(Constants.ROUTE.RECRUITER_DASHBOARD_COMMON_HANDLER),
        data: data
    }).then( res => {
        //Some initial processing like Valid User Check
        //finally call success as server call was success handle other cases in callback function
        let data = res.data.data ;

        //Some initial processing like Valid User Check
        //finally call success as server call was success handle other cases in callback function
        if(res.data && res.data.error === null) {
            let authVo = res.data.authentication_result;
            if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token) {
                onSuccess(data);
            }else{
                handleAuthenticationFailure()
            }
        }else{
            onFailure();
        }
    }).catch((error)=>{
        onFailure();
    });
}

export function xhrGetCoinsInfo (data, onSuccess, onFailure) {
    
    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'get',
        url: appendHttpUrlToApi(Constants.ROUTE.RECRUITER_DASHBOARD_COMMON_HANDLER),
        params: {
            flow_id: data.actionForCoins,
            job_id: data.jobId,
            action_type: Constants.REQUEST_ACTION_TYPE.RECRUITER_DASHBOARD_COMMON_HANDLER.GET_ACTION_GET_COINS_INFO,
        }
    }).then( res => {
        let data = res.data.data;
        if(res.data && res.data.error === null) {
            let authVo = res.data.authentication_result;
            if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token) {
                onSuccess(data);
            }
            else{
                handleAuthenticationFailure()
            }
        }
        else {
            onFailure();
        }
    }).catch((error)=>{
        onFailure();
    });
}

/* BELOW CODE FOR DEV, Comment for Production */
window.CompanyJob = [
    {
        id : 1,
        companyLogoUrl : {"key" : -2, "value" : "https://archive.fo/AFe0E/be5cc87b04facc7ae6cc3479a1e2ad05d4838dea.png"},
        jobDesignation: 'Senior User Experience Designer',
        companyName: 'Treebo',
        locationList: [{id: 1, key: '1', city:{value: 'C'}, area: 'area1'}, {id: 2, key: '2', city:{value: 'Copy'}, area: 'area2'}],
        profileCount: 250,
        coinsRequired: 50,
        rate: 100,
        totalPricing: 5000,
        coinsCount: function()  {
            return this.profileCount * 0.4;
        },
        pricing: function()  {
            return this.coinsCount() * 100;
        }
    },
    {
        id : 2,
        companyLogo : {"key" : -2, "value" : "https://images.unsplash.com/photo-1522199780729-a356c844222a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=1bd52b437d57c3bfa14ccb7c6985b02e&auto=format&fit=crop&w=752&q=80"},
        companyName: 'Treebo 2',
        designation: 'Senior Principal Designer',
        companyLocationList: [{id: 1, key: '1', city:{value: 'Copy'}, area: 'area1'}, {id: 2, key: '2', city:{value: 'C'}, area: 'area2'}],
    }
];

function requestDummyType1 (params, onSuccess) {
    window.CompanyJob.forEach((item, index) => {
        if(params.id === item.id) {
            onSuccess(window.CompanyJob[index]);
        }
    });
}

function requestDummyType2(data, onSuccess) {
    let dbAccessCountProfileInfo;

    dbAccessCountProfileInfo = {
        coinsCount : 0.4 * (data.get("profileCount")),
        pricing : 100 * Math.ceil(0.4 * (data.get("profileCount")))
    };
    let timer = setTimeout(()=>{
        onSuccess(dbAccessCountProfileInfo);
    }, 1000);

    return function () {
        clearTimeout(timer);
        console.log("dummy request canceled");
    };
}

function responseDummyType2(data, onSuccess) {
    let CompanyJobList = window.CompanyJob, dbAccessUpgrade;
    let compId = parseInt(data.get("id")), indx;
    dbAccessUpgrade = {
        id: (data.get("id") !== "null") ? parseInt(data.get("id")) : null,
        companyLogoUrl:(data.get("companyLogoUrl") !== "null") ? JSON.parse(data.get("companyLogoUrl")) : null,
        jobDesignation: (data.get("jobDesignation") !== "null") ? data.get("jobDesignation") : null,
        companyName: (data.get("companyName") !== "null") ? data.get("companyName") : null,
        locationList: (data.get("locationList") !== "null") ? JSON.parse(data.get("locationList")) : null,
        profileCount: (data.get("profileCount") !== "null") ? data.get("profileCount") : null,
        rate: (data.get("rate") !== "null") ? data.get("rate") : null,
        // coinsCount: (data.get("coinsCount") !== "null") ? data.get("coinsCount") : null
    };
    CompanyJobList.forEach((item, index) => {
        if(item.id === compId) {
            indx = index
        }
    });
    let test = CompanyJobList[indx] = {...CompanyJobList[indx], dbAccessUpgrade};

    let timer = setTimeout(()=> {
        onSuccess(test);
    }, 1000);

    return function () {
        clearTimeout(timer);
        console.log("dummy request canceled");
    };
}




// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetDataBaseView/Services/Services.js